<div class="map-container" [class.map-container--legend-open]="isLegendOpen()">
  <div class="map-container__map" [id]="mapId()"></div>

  <app-app-download-banner class="map-container__download"></app-app-download-banner>

  <app-map-button-group
    class="map-container__buttons"
    (showLegendClicked)="toggleLegend()"
    (focusMyLocationClicked)="focusMyLocation()"
    (changeLanguageClicked)="changeLanguage()"
    (mapViewToggled)="mapViewToggled($event)"
  />

  @if (isLegendOpen()) {
    <app-legend-panel class="map-container__legend" (closed)="isLegendOpen.set(false)" />
  }

  <app-route-network-search
    class="map-container__search"
    (routeNetworkSelected)="focusMapToLatLng($event)"
  />

  @if (lastRouteData(); as routeData) {
    <app-elevation-profile
      class="map-container__elevation-profile"
      [class.map-container__elevation-profile--sidesheet-open]="!!sideSheetUrl()"
      [routeData]="routeData"
      (closed)="onElevationProfileClosed()"
    />
  }
</div>
